// @ts-strict-ignore
import { Dispatch } from 'redux';

import {
  IntegrationJob,
  IntegrationProvider,
  getIntegrationJobs as apiGetIntegrationJobs,
} from 'api/orgAdmin';

// Types

export type Integration = {
  isFetching: boolean;
  jobs?: Array<IntegrationJob> | null | undefined;
};

export type Integrations = {
  jazzhr?: Integration;
  greenhouse?: Integration;
};

export type MainStoreOrgDashboardIntegrationsState = {
  byId: Record<string, Integrations>;
};

type FetchIntegrationAction = {
  type: 'FETCH_INTEGRATION_ACTION';
  integrationType: IntegrationProvider;
  orgId: string;
};

type FetchIntegrationFailureAction = {
  type: 'FETCH_INTEGRATION_FAILURE_ACTION';
  integrationType: IntegrationProvider;
  orgId: string;
};

type FetchIntegrationSuccessAction = {
  type: 'FETCH_INTEGRATION_SUCCESS_ACTION';
  integrationType: IntegrationProvider;
  jobs: Array<IntegrationJob> | null | undefined;
  orgId: string;
};

export type MainStoreOrgDashboardIntegrationsAction =
  | FetchIntegrationSuccessAction
  | FetchIntegrationAction
  | FetchIntegrationFailureAction;

// Reducer

const initialState = {
  byId: {},
};

export function integrationsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreOrgDashboardIntegrationsState = initialState,
  action: MainStoreOrgDashboardIntegrationsAction
) {
  switch (action.type) {
    case 'FETCH_INTEGRATION_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs:
          orgIntegrations && orgIntegrations[action.integrationType]
            ? orgIntegrations[action.integrationType].jobs
            : [],
        isFetching: true,
      };
      return {
        ...state,
        byId: { ...state.byId, [action.orgId]: orgIntegrations },
      };
    }

    case 'FETCH_INTEGRATION_FAILURE_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs: [],
        isFetching: false,
      };
      return {
        ...state,
        byId: { ...state.byId, [action.orgId]: orgIntegrations },
      };
    }

    case 'FETCH_INTEGRATION_SUCCESS_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs: action.jobs,
        isFetching: false,
      };
      return {
        ...state,
        byId: { ...state.byId, [action.orgId]: orgIntegrations },
      };
    }

    default:
      return state;
  }
}

// Actions

export const clearIntegrationJobs =
  (orgId: string, type: IntegrationProvider) =>
  (dispatch: Dispatch<MainStoreOrgDashboardIntegrationsAction>) => {
    dispatch({
      type: 'FETCH_INTEGRATION_SUCCESS_ACTION',
      integrationType: type,
      orgId,
      jobs: null,
    });
  };
export const fetchIntegrationJobs =
  (orgId: string, type: IntegrationProvider) =>
  (dispatch: Dispatch<MainStoreOrgDashboardIntegrationsAction>) => {
    dispatch({
      type: 'FETCH_INTEGRATION_ACTION',
      integrationType: type,
      orgId,
    });
    return apiGetIntegrationJobs(orgId, type)
      .then(({ jobs }) => {
        dispatch({
          type: 'FETCH_INTEGRATION_SUCCESS_ACTION',
          integrationType: type,
          orgId,
          jobs,
        });
        return jobs;
      })
      .catch((e) => {
        dispatch({
          type: 'FETCH_INTEGRATION_FAILURE_ACTION',
          integrationType: type,
          orgId,
        });
        return e;
      });
  };
